export default __webpack_public_path__ + "assets/images/inprogress-legend.png";